import { render, staticRenderFns } from "./BillingStatementReview.vue?vue&type=template&id=74965c94&"
import script from "./BillingStatementReview.vue?vue&type=script&lang=js&"
export * from "./BillingStatementReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports